module.exports = __webpack_public_path__ + "static/all-cultures-mobile.91cf2a49.webp";